/*
创建者 程楠
推荐商品
*/
<template>
  <div class="squares" style="text-align:left;">
    <ul class="list_pic clearfix">
      <li class="item" v-for="item in goods" :key="item.goodsId">
        <div class="goods-content-v2">
          <div class="goods-pic">
            <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank">
              <img :src="item.thumbnail" :alt="item.name" />
            </router-link>
            <span class="goods-pic-tag" v-bind:style="{color: item.topBgcolor}">{{ item.topRightContent }}</span>
          </div>
          <div class="goods-info">
            <div v-if="item.name" class="goods-name">
              <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank">
                <span v-html="item.name"></span>
              </router-link>
            </div>
            <div class="goods-price">
              <em class="sale-price" :title="'换购商品积分：'+item.exchangePv">{{item.exchangePv}}</em>
              <em class="exchange-price" :title="'换购价：'+item.exchangePv">￥{{item.exchangePv}}</em>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ["data"],
  directives: {},
  data() {
    return {
      goods: []
    }
  },
  watch: {
    data: function (newVal, oldVal) {
      this.goods = newVal.map(v => {
        if (!v.goodsId) {
          return { ...v, goodsId: v.goodsId };
        }
        return v;
      });
    }
  },
  computed: {},
  methods: {}
}
</script>
<style>
.exchange-price {
  color: #928c8c;
  font-size: 12px;
  text-decoration: line-through;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// exchange-goods.vue?66ea40e2